// Vanilla JS Smooth Scroll plugin from https://github.com/cferdinandi/smooth-scroll
import SmoothScroll from 'smooth-scroll';

let scroll = new SmoothScroll('.validation_error a[href*="#"]', {
	offset: 150,
	emitEvents: true,
});

// Log scroll events
let setFocus = function (event) {
	event.preventDefault();
	let target = event.detail.anchor;
	let firstInput = target.querySelectorAll(
		'input, select, textarea, [tabindex]:not([tabindex="-1"])'
	)[0];
	firstInput.focus();
};

// Listen for scroll events
document.addEventListener('scrollStop', setFocus, false);
